import storage from "../../storage"

export function PasswordChangeGuard(to, from, next) {
    const passwordChanged = storage.local.getPasswordChanged()

    if (!passwordChanged)
        return next('/app/changePassword')

    return next()
}
